import ProductsStore from '../store/ProductsStore';
import { fetchFromJson } from './fetchFromJson';
import { getAvailableClustersForProducts } from '../utils/products';

const db = new ProductsStore('productsDb');

const updateCache = 'products_updateCache';
const getUpdateCache = (data) => data.products;
const toast = 'Products Updated';
const entityName = 'products';

export default (WrappedComponent) => fetchFromJson({
  WrappedComponent,
  getUpdateCache,
  db,
  updateCache,
  toast,
  entityName,
  createIndexOnFetch: (products) => ({
    availableClusters: getAvailableClustersForProducts(products),
  }),
});
